var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useWebMask } from '../hooks/use-web-mask';
export var MaskedInput = React.forwardRef(function (_a, ref) {
    var maskGenerator = _a.maskGenerator, value = _a.value, onChange = _a.onChange, keepMask = _a.keepMask, inputProps = __rest(_a, ["maskGenerator", "value", "onChange", "keepMask"]);
    var maskProps = useWebMask({
        maskGenerator: maskGenerator,
        value: value != null ? "".concat(value) : undefined,
        onChange: onChange,
        keepMask: keepMask,
        ref: ref,
    });
    return React.createElement("input", __assign({}, inputProps, maskProps));
});
//# sourceMappingURL=masked-input.js.map